import { AnyFunc, createEventEmitter, EventEmitter } from '../../shared/util/EventEmitter';
import { HttpServerSentEventClient } from '../HttpServerSentEventClient';

export class HttpServerSentEventClientAdapter implements HttpServerSentEventClient {
  private emitter_: EventEmitter;
  private eventSource_: EventSource | undefined;

  constructor(
    private readonly httpURL: string,
    private readonly initData?: EventSourceInit,
  ) {
    this.emitter_ = createEventEmitter();
  }

  public subscribe(eventName: string, callback: AnyFunc): void {
    this.emitter_.subscribe(eventName, callback);
  }

  public getConnectionStatus(): number | undefined {
    return this.eventSource_?.readyState;
  }

  public unsubscribe(eventName: string, callback: AnyFunc): void {
    this.emitter_.unsubscribe(eventName, callback);
  }

  public init(): void {
    this.eventSource_ = new EventSource(this.httpURL, this.initData);
    this.subscribeToServerSentEvents();
  }

  public release(): void {
    if (!this.eventSource_) {
      return;
    }

    this.emitter_.reset();
    this.unsubscribeToServerSentEvents();
    this.eventSource_.close();
    this.eventSource_ = undefined;
  }

  private subscribeToServerSentEvents = (): void => {
    if (!this.eventSource_) {
      return;
    }

    this.eventSource_.onopen = (event: Event): any => {
      this.emitter_.publish('open', event);
    };

    this.eventSource_.onerror = (event: Event): any => {
      this.emitter_.publish('error', event);
    };
    this.eventSource_.onmessage = (event: MessageEvent): any => {
      this.emitter_.publish('message', event);
    };
  };

  private unsubscribeToServerSentEvents = (): void => {
    if (!this.eventSource_) {
      return;
    }
    this.eventSource_.onopen = null;
    this.eventSource_.onerror = null;
    this.eventSource_.onmessage = null;
  };
}
